import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { authService, AuthUser } from '@/services/auth'

interface RequireAuthProps {
  children: React.ReactNode
}

export default function RequireAuth({ children }: RequireAuthProps) {
  const navigate = useNavigate()
  const location = useLocation()
  const [isChecking, setIsChecking] = useState(true)
  const [user, setUser] = useState<AuthUser | null>(null)

  useEffect(() => {
    const check = async () => {
      try {
        const u = await authService.getCurrentUser()
        if (!u) {
          navigate('/login', { replace: true, state: { from: location.pathname } })
          return
        }
        setUser(u)
      } finally {
        setIsChecking(false)
      }
    }
    check()
  }, [navigate, location.pathname])

  if (isChecking) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="text-center space-y-4">
          <div className="w-10 h-10 border-4 border-white/20 border-t-violet-400 rounded-full animate-spin mx-auto"></div>
          <p className="text-white/70 text-sm">Yükleniyor...</p>
        </div>
      </div>
    )
  }

  if (!user) return null

  return <>{children}</>
}



